// extracted by mini-css-extract-plugin
export default {"standardSize":"Measurement_standardSize__6odMt","part":"Measurement_part__HYu6Y","img":"Measurement_img__4rvjL"};